export default __webpack_public_path__ + "static/media/left-arrow (5) 1.e413a134.svg";